import { httpApi } from '@app/api/http.api'

export type InverterRequest = {
  name: string
  type: string
  manufacturer: string
  code: string
  /** Backend czyta listę błędów wyłącznie z `errorsList` (`InvertersService.createInverter`
   *  / `updateInverter`) i oczekuje pól `value` oraz `solution`. */
  errorsList?: InvertersError[]
}

/** `GET inverters/all` zwraca wyłącznie te pola (patrz `InvertersService.getAllInverters`).
 *  Lista falowników i selecty w formularzu urządzenia nie potrzebują listy błędów. */
export type InverterListItem = {
  id: string
  name: string
  type: string
  manufacturer: string
}

/** `GET inverters/:id` — dokłada `code` i listę błędów potrzebną w formularzu falownika. */
export type GetInverterResponse = InverterListItem & {
  code: string
  errorsList: InvertersError[]
}

export type InvertersError = {
  id?: string
  language: string
  value: string
  description: string
  solution: string
}

export type InvertersToDevice = {
  id: string
  deviceId: string
  inverterId: string
  dataType: string
  index: string
  messageId: string | null
  bitIndex: string | null
  createdAt: Date
  updatedAt: Date
}

export type InverterToDeviceWithInverterWithErrors = {
  inverterToDevice: InvertersToDevice
  inverter: GetInverterResponse
}

export type DeviceErrorDetails = {
  createdAt: Date
  resolvedDate: Date | null
  confirmedDate: Date | null
  inverterDeviceConnection?: {
    dataType: string
    index: number
    mechanism: string
  }
  inverterErrorDetails: {
    id: string
    language: string
    value: string
    description: string
    solution: string
  }[]
}

const INVERTERS = 'inverters'

export const getInverter = (id: string): Promise<GetInverterResponse> =>
  httpApi.get<GetInverterResponse>(`${INVERTERS}/${id}`).then(({ data }) => data)

export const getAllInverters = (): Promise<InverterListItem[]> =>
  httpApi.get<InverterListItem[]>(`${INVERTERS}/all`).then(({ data }) => data)

export const createInverter = (createInverterPayload: InverterRequest): Promise<GetInverterResponse> =>
  httpApi
    .post<GetInverterResponse>(`${INVERTERS}/create-inverter`, { ...createInverterPayload })
    .then(({ data }) => data)

export const updateInverter = (id: string, updateInverterPayload: InverterRequest): Promise<GetInverterResponse> =>
  httpApi
    .put<GetInverterResponse>(`${INVERTERS}/update-inverter/${id}`, { ...updateInverterPayload })
    .then(({ data }) => data)

export const deleteInverter = (id: string): Promise<GetInverterResponse> =>
  httpApi.delete<GetInverterResponse>(`${INVERTERS}/${id}`).then(({ data }) => data)

export const getDeviceErrorDetails = (id: string, language: string): Promise<DeviceErrorDetails> =>
  httpApi.get<DeviceErrorDetails>(`${INVERTERS}/error-details/${id}`, { params: { language } }).then(({ data }) => data)
